import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import { EmailCaptureEditor } from '@/components/vsleads/email-capture/EmailCaptureEditor';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';

export default function EmailCaptureResource() {
  useLanguage();
  const { id } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const captureType = searchParams.get('tipo');

  const isEditMode = !!id;
  const isPasswordCapture = captureType === 'captura-senha';

  // Determinar o título baseado no modo e tipo
  const getTitle = () => {
    if (isEditMode) {
      return isPasswordCapture ? translateInterfaceText("Editar Captura com Senha") : translateInterfaceText("Editar Formulário com E-mail");
    }
    return isPasswordCapture ? translateInterfaceText("Criar Captura com Senha") : translateInterfaceText("Criar Formulário com E-mail");
  };

  const getBreadcrumbText = () => {
    if (isEditMode) {
      return isPasswordCapture ? translateInterfaceText("Editar Captura com Senha") : translateInterfaceText("Editar Captura com E-mail");
    }
    return isPasswordCapture ? translateInterfaceText("Criar Captura com Senha") : translateInterfaceText("Criar Captura com E-mail");
  };

  return (
    <Layout fixedSidebar>
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <div className="flex-shrink-0 bg-transparent">
          <div className="max-w-[1600px] w-full mx-auto px-4 md:px-8 pt-4 pb-4">
            <h1 className="text-[20px] md:text-[22px] font-semibold text-[#1E2330] tracking-tight leading-[1.2]">
              {getTitle()}
            </h1>
          </div>
          <div className="hidden lg:block h-px w-full" style={{ backgroundColor: 'rgba(0, 0, 0, 0.08)', marginTop: '5px'}} />
        </div>

        {/* Breadcrumb */}
        <div className="max-w-[1600px] w-full mx-auto px-4 md:px-8 pt-6">
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href="/vsleads">
                  {translateInterfaceText("Captura de Leads")}</BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage>
                  {getBreadcrumbText()}
                </BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        {/* Main Content */}
        <main className="flex-1 overflow-hidden">
          <div className="max-w-[1600px] w-full mx-auto h-full">
            <div className="px-6 py-6 h-full">
              <EmailCaptureEditor isEditMode={isEditMode} isCapturePassword={isPasswordCapture} />
            </div>
          </div>
        </main>
      </div>
    </Layout>
  );
}
